import React from 'react';
import c from 'classnames';

import './style.scss';

export interface IconListItem {
  key: string,
  text: string,
  icon?: string,
}

interface IconListProps {
  className?: string,
  listItems: IconListItem[],
  large?: boolean
}

const IconList: React.FC<IconListProps> = ({ className, listItems, large }) => {
  const classNames = c(
    'IconList',
    className,
    {
      'IconList--large': large,
    },
  );

  return (
    <ul className={classNames}>
      {listItems.map(({ key, text, icon = 'check' }) => {
        const listClasses = c('icon-before', `icon-${icon}`);
        return (
          <li key={key} className={listClasses}>{text}</li>
        );
      })}
    </ul>
  );
};

export default IconList;
